<template>
  <div class="page_body">
    <HomeTop :topTitle="topTitle"></HomeTop>
    <div class="exam_manual_list_body">
      <div class="exam_manual_list">
        <div
          class="exam_manual_list_item"
          v-for="(item, index) in manualList"
          :key="index"
          @click="toPdfViewerFn(item)"
        >
          <div class="exam_manual_list_item_title">{{ item.title }}</div>
          <div class="exam_manual_list_item_desc">{{ item.desc }}</div>
          <div class="exam_manual_list_item_arrow">
            <img
              class="exam_manual_list_item_arrow_img"
              src="../../assets/image/to_icon01.png"
            />
          </div>
        </div>
      </div>
    </div>
    <HomeFooter :activeKey="activeKey"></HomeFooter>
  </div>
</template>
<style src="../../assets/css/examManual/examManualList.css" scoped></style>

<script>
import HomeFooter from "@/components/homeFooter.vue";
import HomeTop from "@/components/homeTop.vue";

export default {
  name: "ExamManualList",
  components: {
    HomeFooter,
    HomeTop,
  },
  data() {
    return {
      activeKey: 1,
      topTitle: "考试手册",
      manualList: [
        {
          id: 1,
          title: "一至三级考试手册",
          desc: "查看一至三级考试手册",
          pdfUrl: "https://shslqxh.1meeting.com/api/download/2025%E5%B9%B4%E4%B8%8A%E6%B5%B7%E5%B8%82%E7%AF%AE%E7%90%83%E5%8D%8F%E4%BC%9A%E9%9D%92%E5%B0%91%E5%B9%B4%E7%AF%AE%E7%90%83%E6%8A%80%E8%83%BD%E7%AD%89%E7%BA%A7%E8%80%83%E4%B8%80%E8%87%B3%E4%B8%89%E7%BA%A7%E8%80%83%E8%AF%95%E6%89%8B%E5%86%8C%E6%A8%A1%E6%9D%BF.pdf", // 这里需要替换为实际的PDF路径
        },
        {
          id: 2,
          title: "四级考试手册",
          desc: "查看四级考试手册",
          pdfUrl: "https://shslqxh.1meeting.com/api/download/2025%E5%B9%B4%E4%B8%8A%E6%B5%B7%E5%B8%82%E7%AF%AE%E7%90%83%E5%8D%8F%E4%BC%9A%E9%9D%92%E5%B0%91%E5%B9%B4%E7%AF%AE%E7%90%83%E6%8A%80%E8%83%BD%E7%AD%89%E7%BA%A7%E8%80%83%E5%9B%9B%E7%BA%A7%E8%80%83%E8%AF%95%E6%89%8B%E5%86%8C%E6%A8%A1%E6%9D%BF.pdf", // 这里需要替换为实际的PDF路径
        },
      ],
    };
  },
  created: function () {},
  methods: {
    // 跳转到PDF查看页面
    toPdfViewerFn: function (item) {
      this.$router.push({
        name: "PdfViewer",
        params: {
          title: item.title,
          pdfUrl: item.pdfUrl,
        },
      });
    },
  },
};
</script>


